import React, { useState, createRef, useEffect, FC } from 'react';

import '../Dropdown.scss';

type Props = {
    label: any;
    className?: string;
    animation?: any;
    offset?: number;
    fitContent?: boolean;
}

const DropdownMenu: FC<Props> = ({ children, label, className = '', animation = null, offset = 0, fitContent = true }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const node = createRef<HTMLDivElement>();

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        setAnchorEl(null);
    };

    const handleClick = (e: { target: any; }) => {
        const current = node.current;
        if (current && current!.contains(e.target)) {
            return;
        }
        setAnchorEl(null);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    });

    return (
        <div ref={node} className={className ? 'dropdown-container ' + className : 'dropdown-container'}
            onClick={open ? handleClose : handleMenu}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div className='dropdown-label'>
                    {label}
                </div>
            </div>
            <ul className={open ? 'dropdown-select open' : 'dropdown-select'} style={{ transform: `translate(${offset}%, 0)`, width: (fitContent? 'fit-content' : '')  }}>
                {children}
            </ul>
            { animation}
        </div>
    );
}


export default DropdownMenu;
